import { ReactNode } from 'react';
import { Box, Flex, HStack, Text, Image } from '@chakra-ui/react';

import bigLogo from 'assets/img/carriers/big-logo.png';

interface QuoteCarrierHeaderProps {
  carrierName: string;
  quoteRef?: string | null;
  actions?: ReactNode;
}

const carrierLogoMap: Record<string, string> = {
  big: bigLogo,
};

const QuoteCarrierHeader = ({
  carrierName,
  quoteRef,
  actions,
}: QuoteCarrierHeaderProps) => {
  const carrierKey = carrierName.toLowerCase().replace(/\s+/g, '_');
  const logoSrc = carrierLogoMap[carrierKey] || null;

  return (
    <Box borderWidth="1px" borderRadius="lg" p={4} mb={4}>
      <Flex justify="space-between" align="center" wrap="wrap" gap={4}>
        <HStack spacing={4}>
          {logoSrc ? (
            <Image src={logoSrc} alt={carrierName} maxH="40px" />
          ) : (
            <Box
              bg="gray.100"
              px={3}
              py={2}
              borderRadius="md"
              display="flex"
              alignItems="center"
              justifyContent="center"
              minW="100px"
            >
              <Text fontSize="sm" fontWeight="600" color="gray.600">
                {carrierName}
              </Text>
            </Box>
          )}
          <Box>
            <Text fontSize="lg" fontWeight="600">
              {carrierName}
            </Text>
            <HStack spacing={2} mt={1}>
              {quoteRef && (
                <Text fontSize="sm" color="gray.500">
                  #{quoteRef}
                </Text>
              )}
            </HStack>
          </Box>
        </HStack>

        {actions && <HStack spacing={3}>{actions}</HStack>}
      </Flex>
    </Box>
  );
};

export default QuoteCarrierHeader;
